import { Check } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export function FormStepper({
  steps,
  currentStep,
}: {
  steps: string[]
  currentStep: number
}) {
  return (
    <div className="flex items-center justify-center gap-0 w-full px-2 py-2">
      {steps.map((label, i) => {
        const isCompleted = i < currentStep
        const isActive = i === currentStep
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            {/* Step circle + label */}
            <div className="flex flex-col items-center gap-1.5 min-w-[48px]">
              <div
                className={cn(
                  'flex h-7 w-7 items-center justify-center rounded-full text-[11px] transition-all duration-150',
                  isActive
                    ? 'bg-[var(--green)] text-[var(--bg)]'
                    : isCompleted
                      ? 'border border-[var(--green)] bg-transparent text-[var(--green)]'
                      : 'border-[0.5px] border-[var(--rule-strong)] bg-transparent text-[var(--ink-3)]'
                )}
              >
                {isCompleted ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </div>
              <span
                className={cn(
                  'text-center text-[9px] uppercase leading-tight tracking-[0.1em]',
                  isActive
                    ? 'text-[var(--ink)]'
                    : isCompleted
                      ? 'text-[var(--green)]'
                      : 'text-[var(--ink-3)]'
                )}
              >
                {label}
              </span>
            </div>

            {/* Connector line */}
            {i < steps.length - 1 && (
              <div
                className={cn(
                  'mx-2 mt-[-14px] h-[0.5px] flex-1',
                  i < currentStep ? 'bg-[var(--green)]' : 'bg-[var(--rule)]'
                )}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
